import {VizConfigCreator} from 'src/components/Viz/config';

import {AllColumns} from './api/series';
import {Dims, Margin} from './commonTypes';

export function getGraphDims(dims: Dims, margin: Margin): Dims {
  return [dims[0] - margin.left - margin.right, dims[1] - margin.top - margin.bottom] as Dims;
}

export function pickColumnConfigs(config: VizConfigCreator, column: AllColumns): VizConfigCreator {
  return {
    forecasts: config.forecasts.filter((c) => c.columns.indexOf(column) > -1),
    observations: config.observations.filter((c) => c.columns.indexOf(column) > -1),
  };
}
